import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 分页组件
import Pagination from "@/components/Pagination";

Vue.use(ElementUI);

// 全局组件挂载
Vue.component('Pagination', Pagination)
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

// 全局注册图标
Vue.component('icon', Icon);

// 引入Highcharts
import Highcharts from 'highcharts/highstock';
import VueHighCharts from 'highcharts-vue';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDrilldown from 'highcharts/modules/drilldown';
import Highcharts3D from 'highcharts/highcharts-3d';
import {picPath} from '@/utils/format.js'

HighchartsMore(Highcharts)
Vue.use(VueHighCharts)
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);

// 适配flex
import '@/common/flexible.js';

// 引入全局css
import './assets/scss/style.scss';
import './font/font.css'
import './font/iconfont.css'
// 引入axios
import http from './http.js'
Vue.prototype.$http = http;
Vue.prototype.picPath = picPath;

//禁止弹框出现背景滚动
Vue.prototype.NoScrolling = function() {
    var mo = function(e) { e.preventDefault() }
    document.body.style.overflow = 'hidden'
    document.addEventListener('touchmove', mo, false)
}
Vue.prototype.scrolling = function() {
        var mo = function(e) {
            e.preventDefault()
        }
        document.body.style.overflow = '' // 出现滚动条
        document.removeEventListener('touchmove', mo, false)
    }
    // 引入萤石云
import EZUIKit from 'ezuikit-js';
Vue.prototype.$EZUIKit = EZUIKit;



//引入echart
import * as echarts from 'echarts';
import 'echarts-gl';
import chinaJson from "./assets/map/china.json"
echarts.registerMap('china', chinaJson)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

// 引入baidu.map
import BaiduMap from 'vue-baidu-map';
// import {VueJsonp} from 'vue-jsonp'
// Vue.use(VueJsonp)
Vue.use(BaiduMap, {
        ak: 'BnKBCnnQGMGiSnEmjgRyhXZRG4MV2YuS'
    })
    // 引入高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: '5a0c1eeb3c3665e4e06c3855b5688a1a',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});


import './permission.js'

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');